import React from 'react'
import {Row, Col, Input, Pagination, Timeline,
  Button, Table, Collapse, message, Spin, Tabs, Tooltip,Modal,DatePicker,Upload,Form} from 'antd'
import common from '@/public/common'
import '../returnGoods/index.less'
import {ajaxApi, fileDownloadApiNew,axiosPost} from '@/server'
import { getCookie, getParmUrl, outformat,getModerId,tokenConfig,getCode,generateUUID,getCookieNew } from '../../public/utils'
import moment from 'moment'
import _,{ set,get,cloneDeep } from 'lodash'
import { TablePipeline, features, BaseTable } from 'ali-react-table'
import '@/static/style/basetable.less'
import { getDifferenceColumns } from './config'
import { UploadOutlined } from '@ant-design/icons';


const { TabPane } = Tabs
const { Panel } = Collapse
const urlLink = common.scpUrl + 'change-stack'
var api = common.scpUrl||'http://192.168.10.9:8120/'

class DeliverDetails extends React.Component {
  constructor (props) {
    super(props)
    this.fileForm = null;
    this.state = {
      sping: false,
      data: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      base_info: {},
      info: [],
      search: {},
      word: '展开',
      contentData: [],
      contentText: '--',
      isModalOpen:false,
      expectDate:null,
      logisticsInfo:[],
      differencepipelineState:{},
      differenceInfo:{
        list: [],
      },
      loading: false,
      fileList: {},
      activeKey: 'product',
      fileLoading: {},
    }
  }
  

  
  async componentDidMount () {
    this.getDetails()
    await this.getList()
    this.getDifferenceInfo()
    if (getParmUrl('Files')) {
      this.setState({
        activeKey:'files'
      })
    }
  }

  getDifferenceInfo=async()=>{
    try{
      let res = await ajaxApi({
        url:api+'supplier-delivery-scs/difference',
        params:{delivery_id:getParmUrl('DeliveryID'),key_word:''}
      })
      this.setState({differenceInfo:get(res,'data.data')})
      console.log(res)
    }catch(err){console.log(err)}
   }
   // 查询发货单寄送信息，发货单基本信息
   getDetails = async() => {
     let param = {
       DeliveryID: getParmUrl('DeliveryID'),
       s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null
     }
     try{

     ajaxApi({
       url: urlLink + '/Purchase',
       params: {
         data: param,
         action: 'getdeliveryinfo',
       }
     }).then(res => {
       if (res.data.error_code === 0) {
         this.setState({
           info: res.data.data
         })
       } else {
         message.error(res.data.error_message)
       }
     })
     let deliveryRes = await  ajaxApi({
      url: urlLink + '/DeliveryNote',
      action: 'getdeliverynoteinfo',
       params: {
         data: param,
         action: 'getdeliverynoteinfo',
       }
    })
       if (deliveryRes.data.error_code === 0) {
         var data = deliveryRes.data.data
         var logistics_code = _.compact(get(data, 'logistics_code') && get(data, 'logistics_code').split(',') || [])
         var logisticsCompanys = _.compact(get(data, 'log_name') && get(data, 'log_name').split(',')||[])
         var logisticsInfoArr = await Promise.all((logistics_code || []).map((item, index) => {
           var params = {
             company: get(logisticsCompanys, index)||get(logisticsCompanys, 0),
             billnum: item && item.trim(),
           }
           try {
             return ajaxApi({
               url: api + 'supplier-delivery-scs/logistics-content',
               params
             }).then(res => {
               return  {code: item, info:get(res, 'data.data') || []}
             }).catch(err => {
               return {code: item, info:[]}
             })
           } catch (err) { console.log(err) }
         }))
         this.setState({
           base_info: data,
           logisticsInfo:logisticsInfoArr
         },()=>{
         this.getFilelistFun()
         })
       }
    }catch(err){console.log(err)}
   }

   // 获取列表信息
   getList = () => {
     this.setState({
       sping: true
     }, () => {
       let param = {
         ...this.state.search,
         DeliveryID: getParmUrl('DeliveryID'),
         s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null
       }
       ajaxApi({
         url: urlLink + '/Purchase',
         params: {
          action: 'getsupplierdeliverydetail',
          pageIndex: this.state.pageNo,
          pageSize: this.state.pageSize,
          data: param
         }
       }).then((res) => {
         if (res.data.error_code === 0) {
            var data = res.data.data
           this.setState({
             data: typeof (data) === 'string' ? [] : data,
             sping: false,
             total:res.data.total_count
           })
         } else {
           message.error(res.data.error_message)
         }
       })
     })
   }
   // 层叠方法
   colChange = (e) => {
     if (e.length > 0) {
       this.setState({
         word: '隐藏'
       })
     } else {
       this.setState({
         word: '展开'
       })
     }
   }
   // 搜索条件input框值更改
   inputChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val.target.value
     this.setState({
       search: _obj
     })
   }
   // 搜索
   search = () => {
     this.setState({
       pageNo: 1,
       pageSize: 15
     }, () => {
       this.getList()
     })
   }
   // 表格分页
   pageOnChange = (val) => {
     this.setState({
       pageNo: val
     }, () => {
       this.getList()
     })
   }
   sizeOnchange = (current, size) => {
     this.setState({
       pageNo: current,
       pageSize: size
     }, () => {
       this.getList()
     })
   }
   // 导出
   export = () => {
    fileDownloadApiNew({
       url: urlLink + '/deliveryExport',
      param: {
         action: 'getdeliverylistexport',
        //  DeliveryID: getParmUrl('DeliveryID'),
        delivery_code_list:[(this.state.base_info.delivery_code).replace('L', 'F')],
         ProductCode: this.state.search.ProductCode,
         ProductName: this.state.search.ProductName,
         token: getCookie('scs_token') ||'',
         userId: getCookie('accountId') || '',
         s_code:getCookie('supplier_code') ? getCookie('supplier_code'): null
      },
      filename: '发货单_' + moment(new Date()).format('YYYYMMDDHHmmss') + '.xls',
     }).then(res => {

     })
   }

   // 查看批次数量
   getContent=async (record) => {
     const param = {
       product_id: record.ProductID || '',
       detail_id: record.DeliveryDetailID || '',
       lh_id: record.DeliveryID || '',
       rk_quantity: record.InStockQuantity || '',
       batch_no: record.Lot || ''
     }
     const res = await ajaxApi({
       url: common.scpUrl + '/base/query-rk-detail',
       params: param
     })
     if (res.status === 200 && res.data.data) {
       this.setState({
         contentData: res.data.data
       })
     }
   }
  openChangeDate=(e)=>{
    let { base_info } = this.state
    this.setState({
      isModalOpen:true,
      expectDate:get(base_info,'expect_date')?moment(get(base_info,'expect_date')):null
    });
    e.stopPropagation()
  }

  changeDate=(expectDate)=>{
    this.setState({expectDate})
  }

  handleOk=async()=>{
    let { expectDate }  = this.state
    var expectDateLong = moment(expectDate).valueOf()
    if(!expectDate){
      message.error('请选择预计到货日期')
      return 
    }
    if(expectDateLong< moment().startOf('day')){
      message.error('预计到货日期不能小于今天！')
      return 
    }
    this.setState({
      changeLoading:true
    },()=>{this.changeDateAxios(expectDateLong)})
  }

  changeDateAxios=async(expectDateLong)=>{
    let { base_info }  = this.state
    try{
      let res= await ajaxApi({
        url:common.scpUrl+"supplier-delivery-scs/update-delivery-expect-date",
        params:{
          delivery_code:get(base_info,'delivery_code'),
          expect_date:expectDateLong,
          mod_time:moment().valueOf(),
          moder:10
        }
      })
      if(res.status==200){
        message.success('修改成功！')
        setTimeout(()=>{window.location.reload()},1500)
      }
      
    }catch(err){console.log(err);this.setState({isModalOpen:false})}
  }

  handleCancel=()=>{
    this.setState({isModalOpen:false,expectDate:null,changeLoading:false})
  }

  getDifferencePipeline = () => {
    let { differenceInfo } = this.state
    const pipeline = new TablePipeline({
      state: this.state.differencepipelineState,
      setState: (updater) => {
        // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
        // updater 接受原来的 pipelineState，返回新的 pipelineState
        this.setState({
          differencepipelineState: (prev) => { return updater(prev.pipelineState) }
        })
      }
    })
    pipeline.input({ dataSource: this.setRolSpan(get(differenceInfo, 'list') || []), columns: getDifferenceColumns() })
    pipeline.primaryKey('only_key')
    pipeline.use(features.autoRowSpan())
    return pipeline
  }
  setRolSpan = (list) => {
    list = list.map(item => {
      var diff_key = get(item, 'po_id') + '_' + get(item, 'product_id')
      var newItem = { ...item, diff_key, only_key: diff_key + '_' + get(item, 'batch_no') }
      return newItem
    })
    var cloneData = _.cloneDeep(list)
    list = list.map(item => {
      var newItem = { ...item }
      var sameList = _.filter(cloneData, ['diff_key', get(item, 'diff_key')])
      set(newItem, 'diff', _.cloneDeep(sameList))
      //总入库数量
      set(newItem, 'all_in_stock_quantity', _.sumBy(_.cloneDeep(sameList), 'in_stock_quantity'))
      //总数是否差异
      var all_is_diff = _.sumBy(_.cloneDeep(sameList), 'qty') != get(newItem, 'all_in_stock_quantity')
      //批次是否差异
      var batch_is_diff = get(newItem, 'qty') != get(newItem, 'in_stock_quantity')
      var diff_info = all_is_diff ? '总数有差异' : "总数无差异"
      diff_info = diff_info + (get(newItem, 'batch_no') && batch_is_diff ? '，批次有差异' : "，批次无差异")
      set(newItem, 'diff_info', diff_info)
      set(newItem, 'diff_key_diff_info', get(item, 'diff_key') + diff_info)
      set(newItem, 'diff_key_all_in_stock_quantity', get(item, 'diff_key') + get(newItem, 'all_in_stock_quantity'))
      return newItem
    })
    return list
  }

  beforeUpload = async (type, file) => {
    let { fileList, fileLoading} = this.state
    this.setState({
      fileLoading:{...fileLoading,[type]:true}
    })
    try {
      let tokenRes = await axiosPost(`${common.scpUrl}/file/upload/token/get`, [file.name])
      let fileNames = get(tokenRes, "data.file_names[0]")
      let upTokens = get(tokenRes, "data.up_tokens[0]")
      let form = new FormData();
      form.append("token", upTokens);
      form.append("file", file);
      form.append("key", fileNames);
      let uploadRes = await axiosPost("https://upload.qiniup.com/", form)
      if (get(uploadRes, "data.hash") && get(uploadRes, "data.key")) {
        const param = {
          delivery_code: get(this.state,'base_info.delivery_code'),
          annex_name: file.name,
          annex_type: type,
          key: fileNames,
          source: 'scs',
          operator: getCode()
        }
        let res = await ajaxApi({
          url: common.scpUrl + "order/upload-annex",
          params: param
        })
        if (get(res, 'data.code') === '0') {
          let imgUrl = `${common.fileUrl}/${get(uploadRes, "data.key")}`
          if (imgUrl) {
            if (get(fileList, `${type}.length`)) {
              fileList[type].push({ uid: file.uid, name: file.name, status: 'done', url: imgUrl })
            } else {
              fileList[type] = [{ uid: file.uid, name: file.name, status: 'done', url: imgUrl }]
            }
            this.setState({
              fileList: cloneDeep(fileList)
            })
          }
        } else {
          message.error(get(res, 'data.message'))
        }
      }
      this.setState({
        fileLoading:{...fileLoading,[type]:false}
      })
      return false
    } catch (err) {
      this.setState({
        fileLoading:{...fileLoading,[type]:false}
      })
      return false
    }
  }

  onRemove = async (type, file) => {
    let { fileList } = this.state
    const param = {
      delivery_code: get(this.state,'base_info.delivery_code'),
      annex_name: file.name,
      source: 'scs',
      operator: getCode(),
    }
    const res = await ajaxApi({
      url: common.scpUrl + "order/delete-annex",
      params: param
    })
    if (get(res, 'data.code') === '0') {
      fileList[type] = fileList[type].filter(item => {
        return item.uid != file.uid
      })
      this.setState({
        fileList: cloneDeep(fileList)
      })
    } else {
      message.error(get(res, 'data.message'))
    }
  }

  downloadUdiTemplate = () => {
    fileDownloadApiNew({
      url: common.escmProUrl + 'supplier-delivery/download-udi-annex-template',
      param: {},
      filename: 'UDI附件导入模板.xlsx'
    })
  }

  getFilelistFun = async () => {
    const res = await ajaxApi({
      url: common.scpUrl + "order/query-annex",
      params: { delivery_code: get(this.state,'base_info.delivery_code')}
    })
    if (get(res, 'data.code') === '0') {
      let data = get(res,'data.data')
      let UDI = (get((data||[]).find(i => i.annex_type === 'UDI'),"annex_list")||[]).map(i => {
        return {
          url: i.annex_url, name: i.annex_name, status: 'done', uid: generateUUID()
        }
      })
      let report = (get((data||[]).find(i => i.annex_type === 'report'),"annex_list")||[]).map(i => {
        return {
          url: i.annex_url, name: i.annex_name, status: 'done', uid: generateUUID()
        }
      })
      let other =  (get((data||[]).find(i => i.annex_type === 'other'),"annex_list")||[]).map(i => {
        return {
          url: i.annex_url, name: i.annex_name, status: 'done', uid: generateUUID()
        }
      })
      this.setState({
        fileList: { UDI: UDI, report: report, other: other }
      })
    }
  }

   render () {
     const { data, total, sping, logisticsInfo, typeList, base_info, info, word, contentData,fileList,fileLoading} = this.state
     const content = (
       <div style={{width: '250px', padding: '8px'}}>
         {contentData.length !== 0 ? contentData.map((item) => {
           return (
             <div style={{marginBottom: '8px'}} key={item.detail_id}>
               <span>批次号：{item.batch_no || '--'}</span>
               <span style={{marginLeft: '16px'}}>入库数量：{item.rk_quantity || item.rk_quantity === 0 ? item.rk_quantity : '--'}</span>
             </div>
           )
         }) : '--'}
       </div>
     )
     const columns = [
       {
         title: '订单编号',
         dataIndex: 'po_code',
         align: 'center'
       },
       {
        title: '货品名称/货品编码',
        dataIndex: 'product_name',
        align: 'left',
        width: 180,
        render: (text,record) => (
          <span>
            {outformat(text)}<br/>
            {get(record,'product_code')}
          </span>
        )
      },
           {
 title: '供应商货品编码',
        dataIndex: 'third_product_code',
     },
       {
         title: '规格型号',
         align: 'center',
         //  width: '200px',
         dataIndex: 'pro_model'
       },
       {
         title: '注册证号',
         dataIndex: 'mdrc',
         align: 'left',
         render: (text) => (
           <span>{text}</span>
         )
       },
       {
         title: '注册人/备案人',
         dataIndex: 'register_name',
         align: 'left',
         render: (text) => (
           <span>{text}</span>
         )
       },
       {
         title: '生产企业（含委托）',
         dataIndex: 'producer',
         align: 'left',
         render: (text) => (
           <span>{text}</span>
         )
       },
       {
         title: '单位',
         dataIndex: 'unit',
         align: 'left'
       },
       {
         title: '定制片参数',
         dataIndex: 'degree',
         align: 'left',
         width: '80px',
         render: (_, record) => (
           <Tooltip title={<div style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
             <div>
               <div>度数</div>
               <div>{record.degree || '--'}</div>
             </div>
             <div>
               <div>散光</div>
               <div>{record.astigmia || '--'}</div>
             </div>
             <div>
               <div>轴位</div>
               <div>{record.axial_position || '--'}</div>
             </div>
             <div>
               <div>基弧</div>
               <div>{record.contact_arc || '--'}</div>
             </div>
             <div>
               <div>换算方式</div>
               <div>{record.is_conversion || record.is_conversion === '0' ? record.is_conversion * 1 ? '是' : '否' : '--'}</div>
             </div>
           </div>}>
             <a>查看</a>
            </Tooltip>
         )
       },
      // {
      //   title: 'UDI',
      //   dataIndex: 'UDI',
      //   align: 'left',
      //   render: (text) => (
      //     <span>{text||'-'}</span>
      //   )
      // },
       {
         title: '批次号',
         dataIndex: 'lot',
         align: 'left'
       },
       {
         title: '生厂日期',
         dataIndex: 'production_date',
         align: 'center'
       },
       {
         title: '失效日期',
         dataIndex: 'expiry_date',
         align: 'center'
       },
       {
         title: '箱号',
         dataIndex: 'box_number',
         align: 'center'
       },
       {
        title: '发货数量',
        dataIndex: 'deliveryed_quantity',
        align: 'center'
      },
       {
         title: '入库数量',
         dataIndex: 'in_stock_quantity',
         align: 'center',
         width:90,
         render: (text, record) => (
           <span>
             <p>{text || text === 0 ? text : '--'}</p>
             {/* <Popover content={content} title={<div style={{padding: '10px'}}>实际入库批次和数量</div>} trigger="click">
               <a style={{color: 'red'}} onClick={() => this.getContent(record)}>查看明细</a>
             </Popover> */}
           </span>

         )
       }
     ]
     const genExtra = () => (
       <span style={{color: '#1890ff'}}>{word}</span>
     )
     return (
       <div className="returnList">
         <Spin spinning={sping}>
           <div className="search">
             <Collapse
               ghost={true}
               onChange={this.colChange}
               expandIconPosition='right'
             >
               <Panel header={[<Row style={{width: '95%', float: 'left'}}>
                 <Col span={8}>
                   <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>发货单号：</label>
                   <Input style={{width: '60%'}} value={base_info.delivery_code ? (base_info.delivery_code).replace('L', 'F') : ''}/>
                 </Col>
                 <Col span={8}>
                   <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>发货单状态：</label>
                   <Input style={{width: '60%'}} value={base_info.status_name}/>
                 </Col>
                 <Col span={8}>
                   <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>预计到货日期：</label>
                   <Input style={{width: '60%'}} value={moment(base_info.expect_date).format('YYYY-MM-DD')}/>
                   {
                    base_info.status_name=="已预约"&&
                    <span style={{ color: 'red',marginLeft:'12px' }} onClick={this.openChangeDate}>修改</span>
                   }
                 </Col>
               </Row>]} key="1" extra={genExtra()}>
                 <Row style={{marginBottom: '25px', width: '93.8%'}}>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>创建人：</label>
                     <Input style={{width: '60%'}} value={base_info.sname}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>物流公司：</label>
                     <Input style={{width: '60%'}} value={base_info.log_name}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>物流单号：</label>
                     <Input style={{width: '60%'}} value={base_info.logistics_code}/>
                   </Col>
                 </Row>
                 <Row style={{marginBottom: '25px', width: '93.8%'}}>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>收货人：</label>
                     <Input style={{width: '60%'}} value= {base_info.is_supplier_delivery ? (base_info.real_name || '') : '视客采购'}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>联系方式：</label>
                     <Input style={{width: '60%'}} value="17372254909"/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>收货仓库：</label>
                     <Input style={{width: '60%'}} value={base_info.stock_name}/>
                   </Col>
                 </Row>
                 <Row style={{marginBottom: '25px', width: '93.8%'}}>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>创建时间：</label>
                     <Input style={{width: '60%'}} value={moment(base_info.add_time).format('YYYY-MM-DD HH:mm:ss')}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>关联单号：</label>
                     <Input style={{width: '60%'}}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>退货单号：</label>
                     <Input style={{width: '60%'}} value={base_info.po_code}/>
                   </Col>
                 </Row>
                 <Row style={{marginBottom: '25px', width: '93.8%'}}>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>收货地址：</label>
                     <Input style={{width: '60%'}} value= {base_info.is_supplier_delivery ? (base_info.address || '') : '江苏省南京市江宁区湖熟镇波光路30号申通仓库内'}/>
                   </Col>
                   <Col span={8}>
                     <label style={{display: 'inline-block', width: '30%', textAlign: 'right'}}>备注：</label>
                     <Input style={{width: '60%'}}/>
                   </Col>
                 </Row>
               </Panel>
             </Collapse>
           </div>
           <div className="returnBody">
             <Tabs type="card" 
             activeKey={this.state.activeKey}
             onChange={(e)=>{this.setState({activeKey:e})
             }}>
               <TabPane tab="货品详情" key="product">
                 <p>货品编码：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'ProductCode')} placeholder="货品编码"/>货品名称：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'ProductName')} placeholder="货品名称"/><Button type="primary" shape="round" onClick={this.search}>查询</Button><Button style={{marginLeft:'20px'}} shape="round" onClick={this.export}>导出</Button></p>
                 <Table bordered columns={columns} dataSource={data} pagination={false} rowKey={record => record.ProductID}/>
                 <div className="pagination">
                   <span className="datanum">{'共' + total + '条数据'}</span>
                   <Pagination showQuickJumper showSizeChanger current={this.state.pageNo} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                 </div>
                 <p style={{textAlign: 'center'}}><Button shape="round" onClick={() => { this.props.history.push('/main/deliverGoods/deliverList') }}>返回</Button></p>
               </TabPane>
               <TabPane tab="物流信息" key="logisticsInfo">
                 <p>发货地址：{info.length > 0 ? info[0].delivery_address : ''}</p>
                 {base_info.is_supplier_delivery ? (
                   <p>收货地址：{base_info.address || '--'}，{base_info.real_name || '--'}，{base_info.phone || '--'}</p>
                 ) : (<p>收货地址：江苏省南京市江宁区湖熟镇波光路30号申通仓库内，视客采购，17372254909</p>)}

                 <Tabs type="card" >
                  {
                    get(logisticsInfo,'length')>0&&
                    logisticsInfo.map((item,index)=>{
                      return (
                        <TabPane tab={"包裹"+(index+1)} key={index}>
                          <div>
                          物流单号：{get(item,'code')}
                          <div>
                          <p>物流信息</p>
                          { get(item,'info.length')>0
                            ? <Timeline>
                              {
                                get(item,'info').map((_item, index) =>
                                  <Timeline.Item style={{ color: index === 0 ? '#ffa500' : '' }}>
                                    <div>{moment(_item.time).format('YYYY/MM/DD HH:mm:ss')} </div> 
                                    <div style={{ maxWidth: '500px' }}>{_item.content}</div>
                                  </Timeline.Item>
                                )
                              }
                            </Timeline>
                            : '暂无物流信息'}
                          </div>
                          </div>
                          </TabPane>
                      )
                    })
                  }
                 </Tabs>
               </TabPane>
               <TabPane tab="差异信息" key="diff">
                 <div className='BaseTable'>
                   <BaseTable
                     isStickyHead
                     className='antd_table_style no_border'
                     {...this.getDifferencePipeline().getProps()}
                   />
                 </div>
               </TabPane>
               <TabPane tab="发货附件" key="files">
                 <Row style={{marginTop:'8px'}}>
                   <Col span={8}>
                     <Form
                       labelCol={{ span: 6 }}
                       wrapperCol={{ span: 18 }}
                       ref={this.fileForm}>
                       <Form.Item
                         name='UDI'
                         label="UDI附件："
                         getValueFromEvent={() => fileList.UDI || []}
                       >
                         <Upload
                           accept=".xls, .xlsx"
                           fileList={fileList.UDI || []}
                           beforeUpload={(file) => { this.beforeUpload('UDI', file); return false }}
                           onRemove={(file) => { this.onRemove('UDI', file) }}
                         >
                           <Button icon={<UploadOutlined />} loading={fileLoading&&fileLoading.UDI}>Excel导入</Button>
                         </Upload>
                         <a
                           style={{ position: 'absolute', top: '8px', left: '120px' }}
                           onClick={() => {
                            this.downloadUdiTemplate()
                           }}>
                           下载模板
                         </a>
                       </Form.Item>
                       <Form.Item
                         name='report'
                         label="质量检测报告："
                         getValueFromEvent={() => fileList.report || []}
                       >
                         <Upload
                           accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                           fileList={fileList.report || []}
                           beforeUpload={(file) => { this.beforeUpload('report', file); return false }}
                           onRemove={(file) => { this.onRemove('report', file) }}
                         >
                           <Button icon={<UploadOutlined />} loading={fileLoading&&fileLoading.report}>上传文件</Button>
                           <span style={{ color: 'gray', marginLeft: '8px' }}>
                             支持拓展名：.rar .zip .doc .docx .pdf .jpg ...
                           </span>
                         </Upload>
                       </Form.Item>
                       <Form.Item
                         name='other'
                         label="其他附件："
                         getValueFromEvent={() => fileList.other || []}
                       >
                         <Upload
                           accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                           fileList={fileList.other || []}
                           beforeUpload={(file) => { this.beforeUpload('other', file); return false }}
                           onRemove={(file) => { this.onRemove('other', file) }}
                         >
                           <Button icon={<UploadOutlined />} loading={fileLoading&&fileLoading.other}>上传文件</Button>
                           <span style={{ color: 'gray', marginLeft: '8px' }}>
                             支持拓展名：.rar .zip .doc .docx .pdf .jpg ...
                           </span>
                         </Upload>
                       </Form.Item>
                     </Form>
                   </Col>
                 </Row>
               </TabPane>
             </Tabs>
           </div>
           <Modal title="修改预计到货日期"
             open={this.state.isModalOpen}
             onCancel={this.handleCancel}
             footer={
               [<Button onClick={this.handleCancel}>取消</Button>,
               <Button type='primary' style={{ marginLeft: '12px' }} onClick={this.handleOk} loading={this.state.changeLoading}>提交</Button>
               ]
             }
           >
             <div>预计到货日期：
               <DatePicker
                 value={this.state.expectDate}
                 disabledDate={(current) => { return current && current < moment().startOf('day') }}
                 onChange={this.changeDate}
               />
             </div>
           </Modal>
         </Spin>
       </div>
     )
   }
}
export default DeliverDetails



// WEBPACK FOOTER //
// ./src/pages/deliverGoods/deliverDetails.js